import { Stack } from '@mui/material';
import { CheckboxControl } from '@myhrbox/myhrbox-frontend-core';
import { useFieldArray, UseFormReturn } from 'react-hook-form';
import { type IAnswerForm } from '..';

interface MultiChoiceAnswerProps {
  form: UseFormReturn<IAnswerForm>;
}

const MultiChoiceAnswer = ({ form }: MultiChoiceAnswerProps) => {
  const { control } = form;
  const { fields } = useFieldArray({
    control,
    keyName: 'formId',
    name: 'parts',
  });

  return (
    <Stack spacing={1.5}>
      {fields.map((field, index) => (
        <CheckboxControl key={field.formId} name={`parts.${index}.checked`} label={field.content} />
      ))}
    </Stack>
  );
};

export default MultiChoiceAnswer;
